import { Component } from '@angular/core';
import { DataBoxComponent } from '@shared/components/data-box/data-box.component';
import { DataItem } from '@shared/models/data-item';
import { FieldsetModule } from 'primeng/fieldset';

@Component({
    selector: 'app-duty-info-dialog',
    imports: [
        FieldsetModule,
    ],
    templateUrl: './duty-info-dialog.component.html',
    styleUrl: './duty-info-dialog.component.scss'
})
export class DutyInfoDialogComponent {
  titleOnDuty = "On Duty";
  titleFDP = "FDP";

  onDutyDataItem: DataItem[] = [
    {
      label: "",
      value: `The total scheduled or actual time from sign-in thru debrief for this duty period.`
    }
  ];
  fdpDataItem: DataItem[] = [
    {
      label: "",
      value: ""
    }
  ];

}
